import React from 'react';
import Slider from 'react-slick';
import { projects } from '../data/proyectsData';
import '../assets/styles/Project.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const defaultImage = 'https://via.placeholder.com/600x400?text=No+Image';

interface ProjectType {
  id: number;
  title: string;
  description: string;
  images?: string[];
  liveLink: string;
  githubLink: string;
  date: string; // nueva propiedad
}

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
};

const Project: React.FC = () => {
  // Obtener los 3 proyectos más recientes
  const latestProjects = [...projects]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 3);

  return (
    <div id="projects">
      <div className="items-container">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
          {latestProjects.map((project: ProjectType) => (
            <div className="project" key={project.id}>
              <a href={project.liveLink} target="_blank" rel="noreferrer">
                <div className="carousel-container">
                  <Slider {...sliderSettings}>
                    {(project.images && project.images.length > 0
                      ? project.images
                      : [defaultImage]
                    ).map((img: string, index: number) => (
                      <div key={index}>
                        <img
                          src={img}
                          className="zoom"
                          alt={`${project.title} ${index + 1}`}
                          style={{
                            width: '100%',
                            maxHeight: '300px',
                            objectFit: 'contain',
                            display: 'block',
                            margin: '0 auto',
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </a>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-date">
                {new Date(project.date).toLocaleDateString()}
              </p>
              <p className="project-description">{project.description}</p>
              <div className="project-buttons">
                {project.githubLink && (
                  <a href={project.githubLink} target="_blank" rel="noreferrer">
                    <button className="btn btn-github">GitHub</button>
                  </a>
                )}
                {project.liveLink && (
                  <a href={project.liveLink} target="_blank" rel="noreferrer">
                    <button className="btn btn-live">Live</button>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="see-more-container">
        <a href="/projects">
          <button className="btn btn-see-more">See More Projects</button>
        </a>
      </div>
      </div>
    </div>
  );
};

export default Project;
